"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfGetEnquiryCommentsResponseDataDto = instanceOfGetEnquiryCommentsResponseDataDto;
exports.GetEnquiryCommentsResponseDataDtoFromJSON = GetEnquiryCommentsResponseDataDtoFromJSON;
exports.GetEnquiryCommentsResponseDataDtoFromJSONTyped = GetEnquiryCommentsResponseDataDtoFromJSONTyped;
exports.GetEnquiryCommentsResponseDataDtoToJSON = GetEnquiryCommentsResponseDataDtoToJSON;
exports.GetEnquiryCommentsResponseDataDtoToJSONTyped = GetEnquiryCommentsResponseDataDtoToJSONTyped;
var PaginationDetailsDto_1 = require("./PaginationDetailsDto");
var EnquiryCommentListItemDto_1 = require("./EnquiryCommentListItemDto");
/**
 * Check if a given object implements the GetEnquiryCommentsResponseDataDto interface.
 */
function instanceOfGetEnquiryCommentsResponseDataDto(value) {
    if (!('comments' in value) || value['comments'] === undefined)
        return false;
    if (!('pagination' in value) || value['pagination'] === undefined)
        return false;
    return true;
}
function GetEnquiryCommentsResponseDataDtoFromJSON(json) {
    return GetEnquiryCommentsResponseDataDtoFromJSONTyped(json, false);
}
function GetEnquiryCommentsResponseDataDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'comments': (json['comments'].map(EnquiryCommentListItemDto_1.EnquiryCommentListItemDtoFromJSON)),
        'pagination': (0, PaginationDetailsDto_1.PaginationDetailsDtoFromJSON)(json['pagination']),
    };
}
function GetEnquiryCommentsResponseDataDtoToJSON(json) {
    return GetEnquiryCommentsResponseDataDtoToJSONTyped(json, false);
}
function GetEnquiryCommentsResponseDataDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'comments': (value['comments'].map(EnquiryCommentListItemDto_1.EnquiryCommentListItemDtoToJSON)),
        'pagination': (0, PaginationDetailsDto_1.PaginationDetailsDtoToJSON)(value['pagination']),
    };
}
